module.exports = __webpack_public_path__ + "static/media/_DSC6399.ab728c3c.jpg";